/**
 * Created by rong on 17/8/2.
 */
import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex)

export default new vuex.Store({
  state: {
    // 学校信息
    schoolInfo: JSON.parse(window.localStorage.getItem('schoolInfo')),
    userInfo: JSON.parse(window.localStorage.getItem('userInfo')),
    cartInfo: JSON.parse(window.localStorage.getItem('cartInfo')),
    wxToken: window.localStorage.getItem('wxToken'),
    wxUid: window.localStorage.getItem('wxUid'),
    openId: window.localStorage.getItem('openId'),
    platformType: window.localStorage.getItem('platformType'),
    orderId: window.localStorage.getItem('orderId'),
    wxLoginToken: window.localStorage.getItem('wxLoginToken'),
    shopCodeInfo: {},
    needRecord: false,
    recordPage: '',
    recordItemHeight: 0,
    recordOtherHeight: 0,
    recordList: 0,
  },
  mutations: {
    //同步
    changeSchoolInfo(state, schoolInfo) {
      state.schoolInfo = schoolInfo
      window.localStorage.setItem('schoolInfo', JSON.stringify(schoolInfo))
    },
    changeCartInfo(state, cartInfo) {
      state.cartInfo = cartInfo
      window.localStorage.setItem('cartInfo', JSON.stringify(cartInfo))
    },
    changeShopCodeInfo(state, shopInfo) {
      state.shopCodeInfo = shopInfo
      window.localStorage.setItem('shopCodeInfo', JSON.stringify(shopInfo))
    },
    changeState(state, obj) {
      for(var key in obj) {
        state[key] = obj[key]
        window.localStorage.setItem(key, obj[key])
      }
    },
    changeUserInfo(state, userInfo) {
      state.userInfo = userInfo
      window.localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    changeRecordState(state, bool) {
      state.needRecord = bool;
    },
    changeRecordPage(state, name) {
      state.recordPage = name;
    },
    changeRecordItemHeight(state, height) {
      state.recordItemHeight = height;
    },
    changeRecordOtherHeight(state, height) {
      state.recordOtherHeight = height;
    },
    changeRecordList(state, list) {
      state.recordList = list;
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js